module.exports = __webpack_public_path__ + "media/images/pic/brodno/team/teachers/kamila-bandurska-360af1104106a82bb96d16f19b1ec3f1.webp";